var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail"},[_c('div',{staticClass:"thumbnail-image"},[_c('picture',[_c('source',{attrs:{"srcset":_vm.image,"type":"image/webp"}}),_c('img',{attrs:{"src":_vm.image,"loading":"lazy"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }